import { createContext, useContext } from "react";

// Состояние множественного выбора сообщений для переноса между чатами.
// Провайдер монтируется только суперадмину (см. ChatShell) — под ним
// MessageItem рисует чек-боксы на импортированных сообщениях. Вне провайдера
// хук возвращает null → чек-боксов нет (обычный пользователь).
export interface MessageSelectionApi {
    /** Отмеченные message_id. */
    selectedIds: string[];
    count: number;
    isSelected: (messageId: string) => boolean;
    toggle: (messageId: string) => void;
    clear: () => void;
}

export const MessageSelectionContext = createContext<MessageSelectionApi | null>(null);

export function useMessageSelection(): MessageSelectionApi | null {
    return useContext(MessageSelectionContext);
}
